/**
 * Normalización alineada con backend `normalize_customer_phone` (customers.py).
 * Misma clave business_id + teléfono en upsert, register-order, benefits-progress, etc.
 */
export function normalizeCustomerPhone(raw) {
  if (raw == null) return '';
  const digits = String(raw).replace(/\D/g, '');
  if (!digits) return '';
  if (digits.length === 9 && digits.startsWith('9')) return `56${digits}`;
  if (digits.length === 10 && digits.startsWith('09')) return `56${digits.slice(1)}`;
  return digits;
}
